import { render, staticRenderFns } from "./AnalyzesReceived.vue?vue&type=template&id=46b239d2&"
import script from "./AnalyzesReceived.vue?vue&type=script&lang=tsx&"
export * from "./AnalyzesReceived.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports